import React, { Component } from "react";

export default class LoadingItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  render() {
    return (
        <div className="col-xl-12">
          <div className="card card-custom gutter-b">
            <div className="card-header"></div>
          </div>
      </div>
    );
  }
}
